import { fetchDataAPI } from '../helpers/fetchDataAPI';
import { URL_BASE_API } from './glogal';
import { store } from '../store'


export const sendMessage = (name, email, message) => {
    const url = `${URL_BASE_API}/api/getintouch/send`;
    const language = store.getState().configuration.language;
    const rsp = fetchDataAPI(url, {
        field01: name,
        field02: email,
        field03: message,
        lang: language
    });
    
    return rsp;
}
